var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{class:[("alert " + _vm.alertType), { 'alert--slim' : _vm.slim }]},[(!_vm.hideTitle)?_c('h3',{staticClass:"alert__title"},[_vm._v(_vm._s(_vm.alertTitle))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }